import { serialize, deserialize } from '#layers/base/utils/serializing'

/**
 * @param {string} key localStorage key
 * @param {T} defaultValue localStorage default value
 */
const useLocalStorage = <T>(key: string, defaultValue: T) => {
  const stored = ref<T>(defaultValue) as Ref<T>

  const get = () =>
    (stored.value = deserialize<T>(
      localStorage?.getItem(key) || serialize<T>(defaultValue),
    ))

  const set = (value: T) => {
    localStorage?.setItem(key, serialize<T>(value))
    get()
  }

  if (import.meta.client) {
    get()
  }

  return {
    stored,
    set,
    get,
  }
}

export default useLocalStorage
